import { DialogTitle, DialogContent } from '@mui/material';
import { StyledDialog } from 'DesignSystem/Overlays/Dialog/DialogDefault/DialogDefault';
import React, { FC } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';
import TableSettingsForm from './TableSettingsForm';
import { ITableSettings } from 'FeatureModules/DataImport/types/dataImport.types';
import PageSubTitle from 'Components/PageSubTitle';

interface ITableSettingsDialogProps extends IDefaultDialogProps {
  settings?: ITableSettings;
  onChangeSettings: (settings: ITableSettings) => void;
}

const TableSettingsDialog: FC<ITableSettingsDialogProps> = ({
  open,
  onClose,
  settings,
  onChangeSettings,
}) => {
  return (
    <StyledDialog open={!!open} onClose={onClose}>
      <DialogTitle>
        <PageSubTitle title="Table Settings" />
      </DialogTitle>
      <DialogContent>
        <TableSettingsForm onSubmit={onChangeSettings} onCancel={onClose} settings={settings} />
      </DialogContent>
    </StyledDialog>
  );
};

export default TableSettingsDialog;
